import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

function getInitialValue(): boolean {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
    return window.matchMedia(QUERY).matches;
}

/**
 * Returns the current value of the `prefers-reduced-motion: reduce` media query and
 * re-renders when the user toggles the OS-level accessibility setting.
 *
 * Safe to call during SSR (returns `false` when `window.matchMedia` is unavailable),
 * so animation-heavy components can opt out of transitions for users who requested it.
 */
export function usePrefersReducedMotion(): boolean {
    const [reduced, setReduced] = useState<boolean>(getInitialValue);

    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
        const media = window.matchMedia(QUERY);
        const listener = (event: MediaQueryListEvent) => setReduced(event.matches);
        media.addEventListener('change', listener);
        return () => media.removeEventListener('change', listener);
    }, []);

    return reduced;
}
